// extracted by mini-css-extract-plugin
export default {"secondaryFont":"Ico_secondaryFont__KktNL","sizeFont":"Ico_sizeFont__Fu+0M"};